import axios, { AxiosInstance } from 'axios';
import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient from '../../adapter/GraphQLClient';
import Country from '../../entity/Country';
import UserPersonalInformation, { Sex } from '../../entity/UserPersonalInformation';

class UserPersonalWebApi {
  private graphqlClient: GraphQLClient;
  private axios: AxiosInstance;

  constructor({ idGraphqlClient }: { idGraphqlClient: GraphQLClient }) {
    this.graphqlClient = idGraphqlClient;
    this.axios = axios.create();
  }

  public getCountries = async (): Promise<List<Country>> => {
    const result = await this.graphqlClient.query(
      gql`
        query countries {
          countries {
            name
            value
          }
        }
      `,
    );
    return List(result.countries).map<Country>((country: any) => Country.fromJSON(country) as Country);
  };

  public getLocation = async (): Promise<string | null> => {
    return await this.axios
      .post('https://ipinfo.io/')
      .then((res: any) => (res.data.country ? res.data.country : null))
      .catch(() => null);
  };

  public getUserPersonalInformation = async (id: string): Promise<UserPersonalInformation> => {
    const result = await this.graphqlClient.query(
      gql`
        query userPersonalInformation($id: ID!) {
          userPersonalInformation(userId: $id) {
            id
            lastName
            firstName
            nationality
            birthdate
            sex
            freezed
          }
        }
      `,
      { id },
    );
    return UserPersonalInformation.fromJSON(result.userPersonalInformation);
  };

  public updatePersonalInformation = async ({
    lastName,
    firstName,
    nationality,
    birthdate,
    sex,
  }: {
    lastName: string;
    firstName: string;
    nationality: string;
    birthdate: string;
    sex: Sex;
  }): Promise<void> => {
    await this.graphqlClient.query(
      gql`
        mutation updateUserPersonalInformation(
          $lastName: String!
          $firstName: String!
          $nationality: String!
          $birthdate: String!
          $sex: SexEnum!
        ) {
          updateUserPersonalInformation(
            input: {
              lastName: $lastName
              firstName: $firstName
              nationality: $nationality
              birthdate: $birthdate
              sex: $sex
            }
          ) {
            id
          }
        }
      `,
      { lastName, firstName, nationality, birthdate, sex },
    );
  };
}

export default UserPersonalWebApi;
